import { useMutation, useQueryClient } from '@tanstack/react-query';
import { EffectRegistrationEvaluationTimeOptionsClient } from 'requests/nswag/nllMedicineTasks/NllMedicineTasksClient';

export default function useDeleteEvaluationTimeOption() {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: async (request: IDeleteEvaluationTimeOptionRequest) => {
      const client = new EffectRegistrationEvaluationTimeOptionsClient();
      return await client.deleteEvaluationTimeOption(
        request.minutes,
        request.alsoRemoveIfCreatedOnChainConfig,
        request.customerId,
      );
    },
    onSuccess: (_, request) => {
      queryClient.invalidateQueries({ queryKey: ['EVALUATION_TIME_OFFSETS', request.customerId] });
    },
  });
}

interface IDeleteEvaluationTimeOptionRequest {
  customerId: string;
  minutes: number;
  alsoRemoveIfCreatedOnChainConfig: boolean;
}
